import { IconGallery } from '@hivebrite/design-system/Icon';

import { INITIAL_IMAGES } from 'hb-builder/components/BuilderComponents/block/Gallery/utils/constants';
import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { defaultTabs } from 'hb-builder/constants/tabs';
import {
  useComponentContext,
  useComponentsContext,
  useRendererContext,
} from 'hb-builder/hooks';
import type { BuilderComponent } from 'hb-builder/types';
import { createNewItem } from 'hb-builder/utils/createNewItem';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

import Settings from '../Settings';

const GalleryTemplateSlider: BuilderComponent<SectionItemAttributes> = () => (
  <div />
); // never used

const RenderBuilder = ({ children }) => {
  const { item } = useComponentContext();
  const { components } = useComponentsContext();

  const { Section } = components;

  return (
    <Section.RenderBuilder attributes={item.attributes}>
      {children}
    </Section.RenderBuilder>
  );
};

const Render = ({
  children,
  item = { id: '', type: '' },
}: RenderProps<DocumentItem<SectionItemAttributes>>) => {
  const { components } = useComponentsContext();
  const { bodyWidth, isMobilePreview, workspaceConfig } = useRendererContext();
  const { Section } = components;

  return (
    <Section.Render
      bodyWidth={bodyWidth}
      components={components}
      isMobilePreview={isMobilePreview}
      item={item}
      workspaceConfig={workspaceConfig}
    >
      {children}
    </Section.Render>
  );
};

GalleryTemplateSlider.componentCategory = 'block';
GalleryTemplateSlider.componentFamily = 'Gallery';
GalleryTemplateSlider.componentIcon = () => IconGallery;
GalleryTemplateSlider.componentLabel = __('Gallery');
GalleryTemplateSlider.componentName = 'GalleryTemplateSlider';
GalleryTemplateSlider.componentTemplateLabel = __('Slider');
GalleryTemplateSlider.componentType = 'section';

GalleryTemplateSlider.canBeDoubleClicked = true;
GalleryTemplateSlider.canBeDragged = true;
GalleryTemplateSlider.canBeListed = true;
GalleryTemplateSlider.canBeSelected = true;
GalleryTemplateSlider.componentClickable = false;

GalleryTemplateSlider.item = ({
  components = {},
  features = {},
  networkFont,
}) => {
  const { GridItem, Section, SliderItem } = components;

  const sliderItem = SliderItem.item({
    attributes: {
      containerPadding: '32px 0px 32px 0px',
      fontFamily: networkFont,
      textColor: 'white',
    },
    children: INITIAL_IMAGES({ features }).map((image, index) =>
      createNewItem(
        GridItem.item({
          image,
          index,
        }),
      ),
    ),
  });

  return Section.item({
    children: [sliderItem],
    features: {
      ...features,
      section: {
        ...features.section,
        fullWidth: true,
        name: GalleryTemplateSlider.componentName,
        type: GalleryTemplateSlider.componentName,
      },
    },
  });
};

GalleryTemplateSlider.toolbar = ['edit', 'drag', 'duplicate', 'delete'];

GalleryTemplateSlider.Settings = Settings;
GalleryTemplateSlider.SettingsTabs = defaultTabs;

GalleryTemplateSlider.Render = Render;
GalleryTemplateSlider.RenderBuilder = RenderBuilder;

export default GalleryTemplateSlider;
